module.exports = __webpack_public_path__ + "static/media/tag.bd7df4bb.svg";